import { render, staticRenderFns } from "./ComponentsTab.vue?vue&type=template&id=6d5505ed&scoped=true&"
import script from "./ComponentsTab.vue?vue&type=script&lang=js&"
export * from "./ComponentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5505ed",
  null
  
)

export default component.exports